import * as jquery from "jquery";
import { Provider } from "mobx-react";
import React, { Component, Suspense } from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import FallBack from "./pages/layouts/partials/FallBack";
import PrivateRoute from "./pages/layouts/PrivateRoute";
import RootStore from "./RootStore";
Object.assign(global, {
  $: jquery,
  jQuery: jquery,
});
const MainLayout = React.lazy(() => import("./pages/layouts/MainLayout"));
const NoSideBarLayout = React.lazy(
  () => import("./pages/layouts/NoSideBarLayout"),
);
const LoginPage = React.lazy(() => import("./pages/LoginPage"));
const ResetPasswordPage = React.lazy(() => import("./pages/ResetPasswordPage"));

const AddNewUserFromLoginPage = React.lazy(
  () => import("./pages/AddNewUserFromLoginPage"),
);

const LoanSummaryDashboardPage = React.lazy(
  () => import("./pages/LoanSummaryDashboardPage"),
);
// const TechnicalAssistanceDetailsPage = React.lazy(() =>
//   import("./pages/TechnicalAssistanceDetailsPage"),
// );
const ProjectPage = React.lazy(() => import("./pages/ProjectPage"));
const ProjectAddPage = React.lazy(
  () => import("./pages/ProjectAddPage"),
  // () => import("./pages/ProjectAddIIPMPage")
);
const ProjectIIPMAddPage = React.lazy(
  () => import("./pages/ProjectAddIIPMPage"),
);

const ProjectDashboardIIPM = React.lazy(
  () => import("./pages/ProjectDashboardIIPM"),
);

const ProjectEditPage = React.lazy(
  () =>
    // import("./pages/ProjectEditPage"),
    import("./pages/NewIIPM"),
);
const OrganizationInfoPage = React.lazy(
  () => import("./pages/OrganizationInfoPage"),
);
const OrganizationStaffInfoPage = React.lazy(
  () => import("./pages/OrganizationStaffInfoPage"),
);
const OrganizationListPage = React.lazy(
  () => import("./pages/OrganizationListPage"),
);
const OrganizationNewPage = React.lazy(
  () => import("./pages/OrganizationNewPage"),
);
const OrganizationEditPage = React.lazy(
  () => import("./pages/OrganizationEditPage"),
);
// const TechnicalAssistancePage = React.lazy(() =>
//   import("./pages/TechnicalAssistancePage"),
// );
const TechnicalAssistance2Page = React.lazy(
  () => import("./pages/TechnicalAssistance2Page"),
);
const TechnicalAssistance3Page = React.lazy(
  () => import("./pages/TechnicalAssistance3Page"),
);
const TechnicalAssistance4Page = React.lazy(
  () => import("./pages/TechnicalAssistance4Page"),
);
const ProjectReportPage = React.lazy(
  () => import("./pages/ProjectReportNewiipmPage"),
  // import("./pages/ProjectReportPage"),
);
const draftProjectPage = React.lazy(
  () => import("./pages/ProjectDraftNewiipmPage"),
);
const FiveYPlanListPage = React.lazy(() => import("./pages/FiveYPlanListPage"));
const FiveYearPlanDetailsPage = React.lazy(
  () => import("./pages/FiveYearPlanDetailsPage"),
);
const ProposalPlanDetailPage = React.lazy(
  () => import("./pages/ProposalPlanDetailPage"),
);
const FiveYearPlanSummaryDashboardPage = React.lazy(
  () => import("./pages/FiveYearPlanSummaryDashboardPage"),
);

const ProposalPlanListPage = React.lazy(
  () => import("./pages/ProposalPlanListPage"),
);

const ProposalPlanSummaryDashboardPage = React.lazy(
  () => import("./pages/ProposalPlanSummaryDashboardPage"),
);

const YearPlanListPage = React.lazy(() => import("./pages/YearPlanListPage"));

const YearPlanListExistingDebtPage = React.lazy(
  () => import("./pages/YearPlanListExistingDebtPage"),
);

const YearPlanListFinancialStatusPage = React.lazy(
  () => import("./pages/YearPlanListFinancialStatusPage"),
);

const MonthlyReportListPage = React.lazy(
  () => import("./pages/MonthlyReportListPage"),
);
const MonthlyReportStaffListPage = React.lazy(
  () => import("./pages/MonthlyReportStaffListPage"),
);

const NewDebtPlanDetailPage = React.lazy(
  () => import("./pages/NewDebtPlanDetailPage"),
);

const ExistingDebtManagePlanDetailsPage = React.lazy(
  () => import("./pages/ExistingDebtManagePlanDetailsPage"),
);

const FinancialReportDetailsPage = React.lazy(
  () => import("./pages/FinancialReportDetailsPage"),
);

const YearPlanDetailForPlanningPage = React.lazy(
  () => import("./pages/YearPlanDetailForPlanningPage"),
);
const LoanSummaryDashboardForPlannerPage = React.lazy(
  () => import("./pages/LoanSummaryDashboardForPlannerPage"),
);

const YearPlanSummaryDashboardPage = React.lazy(
  () => import("./pages/YearPlanSummaryDashboardPage"),
);
const MonthlyReportDetailPage = React.lazy(
  () => import("./pages/MonthlyReportDetailPage"),
);

const ChartPage = React.lazy(() => import("./pages/ChartPage"));
const OPTListPage = React.lazy(() => import("./pages/OPTListPage"));
const ReportPage = React.lazy(() => import("./pages/ReportPage"));
const ReportNscrPage = React.lazy(() => import("./pages/ReportNscrPage"));
const IIPMPage = React.lazy(() => import("./pages/IIPMPage"));
const AgreementPage = React.lazy(() => import("./pages/AgreementPage"));
const CashflowPage = React.lazy(() => import("./pages/CashflowPage"));
const OrganizationImportExportPage = React.lazy(
  () => import("./pages/OrganizationImportExportPage"),
);

const UserPage = React.lazy(() => import("./pages/UserPage"));
const UserNewPage = React.lazy(() => import("./pages/UserNewPage"));
const UserEditPage = React.lazy(() => import("./pages/UserEditPage"));

const ExchangePage = React.lazy(() => import("./pages/ExchangePage"));
const ExchangeCurrencyManagementPage = React.lazy(
  () => import("./pages/ExchangeCurrencyManagementPage"),
);
const ExchangeParamManagementPage = React.lazy(
  () => import("./pages/ExchangeParamManagementPage"),
);
const ExchangeManagementPage = React.lazy(
  () => import("./pages/ExchangeManagementPage"),
);

const RegulationPage = React.lazy(() => import("./pages/RegulationPage"));
const RegulationModalPage = React.lazy(
  () => import("./pages/RegulationModalPage"),
);

const YearPlanOrganizationInfoPage = React.lazy(
  () => import("./pages/YearPlanOrganizationInfoPage"),
);
const SDGsIntoPage = React.lazy(() => import("./pages/SDGIntoPage"));
const SDGForOrgPage = React.lazy(() => import("./pages/SDGForOrgPage"));
const SDGForStaffPage = React.lazy(() => import("./pages/SDGForStaffPage"));
const SDGTrendsPage = React.lazy(() => import("./pages/SDGTrendsPage"));

const SDGProjectEdit = React.lazy(
  () => import("./././modules/project/containers/ProjectDetailTab2_1SDGsEdit"),
);
const ProjectStatus = React.lazy(
  () =>
    import("./././modules/project/containers/ProjectDetailTab2ProjectStatusEditByProjectCode"),
);
const ProjectDetailTab2StatusEditByCode = React.lazy(
  () =>
    import("./././modules/project/containers/ProjectDetailTab2StatusEditByCode"),
);
const SDGProjectEditByCode = React.lazy(
  () =>
    import("./././modules/project/containers/ProjectDetailTab2_1SDGsEditByCode"),
);
const SiteConfigPage = React.lazy(() => import("./pages/SiteConfigPage"));
const EFormListPage = React.lazy(() => import("./pages/EFormListPage"));

const ProjectLogsPage = React.lazy(() => import("./pages/ProjectLogsPage"));
const PlanLogsPage = React.lazy(() => import("./pages/PlanLogsPage"));
const FiveYearPlanDetailsLogsPage = React.lazy(
  () => import("./pages/FiveYearPlanDetailsLogsPage"),
);
const NewDebtPlanDetailLogsPage = React.lazy(
  () => import("./pages/NewDebtPlanDetailLogsPage"),
);

const IipmLoginPage = React.lazy(() => import("./pages/IipmLoginPage"));
const DdplanCallback = React.lazy(() => import("./pages/DdplanCallback"));
const IipmCallback = React.lazy(() => import("./pages/IipmCallback"));

const KeycloakLoginPage = React.lazy(() => import("./pages/KeycloakLoginPage"));

require("./../node_modules/semantic-ui-calendar/dist/calendar.min.js");
require("./../node_modules/semantic-ui-calendar/dist/calendar.min.css");
require("./semantic/semantic.ui.popup.js");
require("./semantic/semantic.ui.transition.js");

class App extends Component {
  public render() {
    return (
      <FallBack inverted={true}>
        <Provider {...RootStore}>
          <BrowserRouter>
            <Switch>
              <Route
                exact
                path="/keycloakLogin"
                component={KeycloakLoginPage}
              />
              <Route exact path="/" component={LoginPage} />
              <Route
                path="/ddplan/signin-callback"
                component={DdplanCallback}
              />
              <Route exact path="/iipm" component={IipmLoginPage} />
              <Route path="/iipm/signin-callback" component={IipmCallback} />
              <Route
                exact
                path="/resetPassword"
                component={ResetPasswordPage}
              />
              <Route
                exact
                path="/addNewUser"
                component={AddNewUserFromLoginPage}
              />
              <Route
                exact
                path="/project/edit/:projectCode/ProjectStatus&access_token=:access_token"
                component={ProjectDetailTab2StatusEditByCode}
              />
              <Route
                exact
                path="/project/edit/:projectCode/status&access_token=:access_token"
                component={ProjectDetailTab2StatusEditByCode}
              />
              <Route
                exact
                path="/project/edit/:projectCode/sdg&access_token=:access_token"
                // render={(props: any) => (
                //   <PrivateRoute
                //     permissionCode={["OG11"]}
                //     {...props}
                //     component={SDGProjectEdit}
                //   />
                // )}
                component={SDGProjectEditByCode}
              />
              <Route
                exact
                path="/proposalPlan/edit/:id/management"
                render={(props: any) => (
                  <NoSideBarLayout>
                    <PrivateRoute
                      permissionCode={["PP007"]}
                      {...props}
                      component={<ProposalPlanDetailPage editMode />}
                    />
                  </NoSideBarLayout>
                )}
              />

              <MainLayout>
                {/* UserPage */}
                <Route path="/user" exact component={UserPage} />
                <Route path="/user/create" component={UserNewPage} />
                <Route path="/user/edit/:id" component={UserEditPage} />

                {/* Dashboard */}
                <Route
                  path="/home"
                  render={(props: any) => (
                    <PrivateRoute
                      permissionCode={["DB01"]}
                      {...props}
                      component={<LoanSummaryDashboardPage />}
                    />
                  )}
                />
                <Route
                  path="/homeStaff"
                  render={(props: any) => (
                    <PrivateRoute
                      permissionCode={["DB02"]}
                      {...props}
                      component={<LoanSummaryDashboardForPlannerPage />}
                    />
                  )}
                />

                {/* Site Config */}
                <Route
                  path="/siteConfig"
                  render={(props: any) => (
                    <PrivateRoute
                      permissionCode={["DM005"]}
                      {...props}
                      component={<SiteConfigPage />}
                    />
                  )}
                />
                {/* eform list */}
                <Route
                  path="/eformList"
                  render={(props: any) => (
                    <PrivateRoute
                      permissionCode={["UA001"]}
                      {...props}
                      component={<EFormListPage />}
                    />
                  )}
                />
                {/*-----------------------------------intro-to-sdgs ----------------------*/}
                <Route
                  path="/sdgs/intro-to-sdgs"
                  render={(props: any) => (
                    <PrivateRoute
                      permissionCode={["DB01"]}
                      {...props}
                      component={<SDGsIntoPage />}
                    />
                  )}
                />
                <Route
                  path="/sdgs/sdgs-for-org"
                  render={(props: any) => (
                    <PrivateRoute
                      permissionCode={["DB01"]}
                      {...props}
                      component={<SDGForOrgPage />}
                    />
                  )}
                />

                <Route
                  path="/sdgs/sdgs-for-staff"
                  render={(props: any) => (
                    <PrivateRoute
                      permissionCode={["DB02"]}
                      {...props}
                      component={<SDGForStaffPage />}
                    />
                  )}
                />

                <Route
                  path="/sdgs/sdgs-trends"
                  render={(props: any) => (
                    <PrivateRoute
                      permissionCode={["DB01"]}
                      {...props}
                      component={<SDGTrendsPage />}
                    />
                  )}
                />
                <Route
                  path="/exchange"
                  render={(props: any) => (
                    <PrivateRoute
                      permissionCode={["DM002"]}
                      {...props}
                      component={<ExchangePage />}
                    />
                  )}
                  // component={ExchangePage}
                />

                <Route
                  path="/exchange-management"
                  render={(props: any) => (
                    <PrivateRoute
                      permissionCode={["DM002"]}
                      {...props}
                      component={<ExchangeManagementPage />}
                    />
                  )}
                  // component={ExchangePage}
                />
                <Route
                  path="/exchange-currency"
                  render={(props: any) => (
                    <PrivateRoute
                      permissionCode={["DM002"]}
                      {...props}
                      component={<ExchangeCurrencyManagementPage />}
                    />
                  )}
                  // component={ExchangePage}
                />
                <Route
                  path="/exchange-param"
                  render={(props: any) => (
                    <PrivateRoute
                      permissionCode={["DM002"]}
                      {...props}
                      component={<ExchangeParamManagementPage />}
                    />
                  )}
                  // component={ExchangePage}
                />

                <Route path="/regulation" exact component={RegulationPage} />
                <Route
                  path="/regulation/edit/:lovKey"
                  component={RegulationModalPage}
                />

                {/* techAssist */}
                {/* <Route
                  exact
                  path="/techAssist"
                  component={TechnicalAssistancePage}
                />
                <Route
                  path="/techAssist/:id/:name"
                  component={TechnicalAssistanceDetailsPage}
                /> */}
                <Route
                  exact
                  path="/projectLogs"
                  render={(props: any) => (
                    <PrivateRoute
                      permissionCode={["DM007"]}
                      {...props}
                      component={<ProjectLogsPage />}
                    />
                  )}
                />
                <Route
                  exact
                  path="/planLogs"
                  render={(props: any) => (
                    <PrivateRoute
                      permissionCode={["DM006"]}
                      {...props}
                      component={<PlanLogsPage />}
                    />
                  )}
                />
                <Route
                  exact
                  path="/5yLoanPlanLogs/:id"
                  render={(props: any) => (
                    <PrivateRoute
                      permissionCode={["DM006"]}
                      {...props}
                      component={<FiveYearPlanDetailsLogsPage />}
                    />
                  )}
                />
                <Route
                  exact
                  path="/newDebtPlanLogs/:id"
                  render={(props: any) => (
                    <PrivateRoute
                      permissionCode={["DM006"]}
                      {...props}
                      component={<NewDebtPlanDetailLogsPage />}
                    />
                  )}
                />
                <Route
                  exact
                  path="/techAssist2"
                  component={TechnicalAssistance2Page}
                />
                <Route
                  exact
                  path="/techAssist3"
                  component={TechnicalAssistance3Page}
                />
                <Route
                  exact
                  path="/techAssist4"
                  component={TechnicalAssistance4Page}
                />
                <Route
                  exact
                  path="/projectReport"
                  component={ProjectReportPage}
                />
                <Route
                  exact
                  path="/project/draft"
                  component={draftProjectPage}
                />
                <Route
                  exact
                  path="/project/government"
                  render={(props: any) => (
                    <PrivateRoute
                      permissionCode={["OG11"]}
                      {...props}
                      component={<ProjectPage source="gov" />}
                    />
                  )}
                />
                <Route
                  exact
                  path="/project"
                  render={(props: any) => (
                    <PrivateRoute
                      permissionCode={["PJ001"]}
                      {...props}
                      component={<ProjectPage source="iipm" />}
                    />
                  )}
                />
                <Route
                  exact
                  path="/project/working"
                  render={(props: any) => (
                    <PrivateRoute
                      permissionCode={["OG11"]}
                      {...props}
                      component={<ProjectPage source="working" />}
                    />
                  )}
                />
                <Route
                  exact
                  path="/project/add/government"
                  render={(props: any) => (
                    <PrivateRoute
                      permissionCode={["OG11"]}
                      {...props}
                      component={<ProjectAddPage source="gov" />}
                    />
                  )}
                />
                <Route
                  exact
                  path="/project/add"
                  render={(props: any) => (
                    <PrivateRoute
                      permissionCode={["PJ003"]}
                      {...props}
                      component={<ProjectIIPMAddPage source="iipm" />}
                    />
                  )}
                />
                <Route
                  exact
                  path="/project/add/working"
                  render={(props: any) => (
                    <PrivateRoute
                      permissionCode={["OG11"]}
                      {...props}
                      component={<ProjectAddPage source="working" />}
                    />
                  )}
                />

                <Route
                  exact
                  path="/project/dashboardiipm"
                  render={(props: any) => (
                    <PrivateRoute
                      permissionCode={["PJ003"]}
                      {...props}
                      component={<ProjectDashboardIIPM />}
                    />
                  )}
                />
                {/* <Route
                  exact
                  path="/project/edit/:projectCode"
                  render={(props: any) => (
                        <PrivateRoute
                          permissionCode={["OG11"]}
                          {...props}
                      component={<ProjectEditPage />}
                        />
                  )}
                /> */}

                {/* Organization */}
                <Switch>
                  <Route
                    exact
                    path="/organization"
                    render={(props: any) => (
                      <PrivateRoute
                        permissionCode={["OG11"]}
                        {...props}
                        component={<OrganizationStaffInfoPage />}
                      />
                    )}
                  />
                  <Route
                    path="/organization/create"
                    // component={OrganizationNewPage}
                    render={(props: any) => (
                      <PrivateRoute
                        permissionCode={["OG06"]}
                        {...props}
                        component={<OrganizationNewPage />}
                      />
                    )}
                  />
                  <Route
                    path="/organization/edit/:id/:name"
                    render={(props: any) => (
                      <PrivateRoute
                        permissionCode={["OG10"]}
                        {...props}
                        component={<OrganizationEditPage />}
                      />
                    )}
                  />
                  <Route
                    path="/organization/:id/:name"
                    render={(props: any) => (
                      <PrivateRoute
                        permissionCode={["OG11"]}
                        {...props}
                        component={<OrganizationInfoPage />}
                      />
                    )}
                  />
                  <Route
                    path="/organizationStaff"
                    render={(props: any) => (
                      <PrivateRoute
                        permissionCode={["OG12"]}
                        {...props}
                        component={<OrganizationListPage />}
                      />
                    )}
                  />
                </Switch>

                {/* Proposal Plan */}
                <Switch>
                  <Route
                    exact
                    path="/proposalPlanListStaff"
                    render={(props: any) => (
                      <PrivateRoute
                        permissionCode={["PP006"]}
                        notStrict
                        {...props}
                        component={<ProposalPlanSummaryDashboardPage />}
                      />
                    )}
                  />
                  <Route
                    exact
                    path="/proposalPlanList"
                    render={(props: any) => (
                      <PrivateRoute
                        permissionCode={["PP001", "PP002"]}
                        notStrict
                        {...props}
                        component={<ProposalPlanListPage />}
                      />
                    )}
                  />
                  <Route
                    exact
                    path="/proposalPlan/create"
                    component={ProposalPlanDetailPage}
                  />
                  <Route
                    exact
                    path="/proposalPlan/edit/:id"
                    render={(props: any) => (
                      <PrivateRoute
                        permissionCode={["PP004"]}
                        {...props}
                        component={<ProposalPlanDetailPage editMode />}
                      />
                    )}
                  />
                  <Route
                    exact
                    path="/proposalPlan/:id"
                    component={ProposalPlanDetailPage}
                  />
                </Switch>

                {/* Monthly Report */}
                <Switch>
                  <Route
                    exact
                    path="/monthlyReportListStaff"
                    render={(props: any) => (
                      <PrivateRoute
                        permissionCode={["RP002"]}
                        {...props}
                        component={<MonthlyReportStaffListPage />}
                      />
                    )}
                  />
                  <Route
                    exact
                    path="/monthlyReportList"
                    render={(props: any) => (
                      <PrivateRoute
                        permissionCode={["RP001"]}
                        {...props}
                        component={<MonthlyReportListPage />}
                      />
                    )}
                  />
                  <Route
                    exact
                    path="/monthlyReport/edit/:id/:name"
                    render={(props: any) => (
                      <PrivateRoute
                        permissionCode={["RP004"]}
                        {...props}
                        component={<MonthlyReportDetailPage editMode />}
                      />
                    )}
                  />
                  <Route
                    exact
                    path="/monthlyReport/:id/:name"
                    component={MonthlyReportDetailPage}
                  />
                </Switch>

                {/* 5Year Loan Plan */}
                <Switch>
                  <Route
                    exact
                    path="/5yLoanPlan"
                    render={(props: any) => (
                      <PrivateRoute
                        permissionCode={["5Y001"]}
                        {...props}
                        component={<FiveYPlanListPage />}
                      />
                    )}
                  />
                  <Route
                    exact
                    path="/5yLoanPlanStaff"
                    render={(props: any) => (
                      <PrivateRoute
                        permissionCode={["5Y006", "5Y002"]}
                        notStrict
                        {...props}
                        component={<FiveYearPlanSummaryDashboardPage />}
                      />
                    )}
                  />
                  <Route
                    exact
                    path="/5yLoanPlan/edit/:id/:planyear"
                    render={(props: any) => (
                      <PrivateRoute
                        permissionCode={["5Y004"]}
                        {...props}
                        component={<FiveYearPlanDetailsPage editMode />}
                      />
                    )}
                  />
                  <Route
                    exact
                    path="/5yLoanPlan/:id/:planyear"
                    component={FiveYearPlanDetailsPage}
                  />
                </Switch>

                {/* Year Loan Plan */}
                <Route
                  path="/yearPlanList"
                  render={(props: any) => (
                    <PrivateRoute
                      permissionCode={["YP001"]}
                      {...props}
                      component={<YearPlanListPage />}
                    />
                  )}
                />
                <Route
                  path="/yearPlanListExistingDebt"
                  render={(props: any) => (
                    <PrivateRoute
                      permissionCode={["YP001"]}
                      {...props}
                      component={<YearPlanListExistingDebtPage />}
                    />
                  )}
                />
                <Route
                  path="/yearPlanListFinancialStatus"
                  render={(props: any) => (
                    <PrivateRoute
                      permissionCode={["YP001"]}
                      {...props}
                      component={<YearPlanListFinancialStatusPage />}
                    />
                  )}
                />
                <Route
                  exact
                  path="/yearPlanListStaff"
                  render={(props: any) => (
                    <PrivateRoute
                      permissionCode={["YP002"]}
                      {...props}
                      component={<YearPlanSummaryDashboardPage />}
                    />
                  )}
                />
                <Route
                  path="/YearPlanOrganizationInfo/:id"
                  component={YearPlanOrganizationInfoPage}
                />
                <Route
                  path="/yearPlanListStaff/:id/:name"
                  component={YearPlanDetailForPlanningPage}
                />

                {/* New Debt Plan */}
                <Switch>
                  <Route
                    exact
                    path="/newDebtPlan/create"
                    component={NewDebtPlanDetailPage}
                  />
                  <Route
                    exact
                    path="/newDebtPlan/edit/:id/:name"
                    render={(props: any) => (
                      <PrivateRoute
                        permissionCode={["YP004"]}
                        {...props}
                        component={<NewDebtPlanDetailPage editMode />}
                      />
                    )}
                  />
                  <Route
                    exact
                    path="/newDebtPlan/:id/:name"
                    component={NewDebtPlanDetailPage}
                  />
                </Switch>

                {/* Existing Debt Plan */}
                <Switch>
                  <Route
                    exact
                    path="/existingDebtPlan/edit/:id/:planyear"
                    render={(props: any) => (
                      <PrivateRoute
                        permissionCode={["YP007"]}
                        {...props}
                        component={
                          <ExistingDebtManagePlanDetailsPage editMode />
                        }
                      />
                    )}
                  />
                  <Route
                    exact
                    path="/existingDebtPlan/:id/:planyear"
                    component={ExistingDebtManagePlanDetailsPage}
                  />
                </Switch>
                {/* Financial Report */}
                <Switch>
                  <Route
                    exact
                    path="/financialReport/:id/:planyear"
                    component={FinancialReportDetailsPage}
                  />
                  <Route
                    exact
                    path="/financialReport/edit/:id/:planyear"
                    render={(props: any) => (
                      <PrivateRoute
                        permissionCode={["YP010"]}
                        {...props}
                        component={<FinancialReportDetailsPage editMode />}
                      />
                    )}
                  />
                </Switch>
                {/*  */}
                <Route
                  path="/opt"
                  render={(props: any) => (
                    <PrivateRoute
                      permissionCode={["DLA001"]}
                      {...props}
                      component={<OPTListPage />}
                    />
                  )}
                />
                <Route
                  path="/iipm-page"
                  render={(props: any) => (
                    <PrivateRoute
                      permissionCode={["DM001"]}
                      {...props}
                      component={<IIPMPage />}
                    />
                  )}
                />
                <Route
                  path="/agreement"
                  render={(props: any) => (
                    <PrivateRoute
                      permissionCode={["DM001"]}
                      {...props}
                      component={<AgreementPage />}
                    />
                  )}
                />
                <Route
                  path="/cashflow"
                  render={(props: any) => (
                    <PrivateRoute
                      permissionCode={["DM001"]}
                      {...props}
                      component={<CashflowPage />}
                    />
                  )}
                />
                <Route
                  path="/organization/importExportOrganization"
                  render={(props: any) => (
                    <PrivateRoute
                      permissionCode={["DM001"]}
                      {...props}
                      component={<OrganizationImportExportPage />}
                    />
                  )}
                />

                <Route path="/report/nscr" component={ReportNscrPage} />
                <Route path="/report" component={ReportPage} />
                <Route path="/chart" component={ChartPage} />
              </MainLayout>
            </Switch>
          </BrowserRouter>
        </Provider>
      </FallBack>
    );
  }
}

export default App;
